<template>
  <div>
    <div class="TitleFont">
      <!-- 热门游戏 -->
      <p>{{$t('gamelist.hotGame')}}</p>
      <!-- {{ showMore ? '收起' : '更多'}} -->
      <!-- 全部游戏 -->
      <el-button type="text"
                 @click="toMore">{{$t('gamelist.allGame')}}</el-button>
      <!-- <el-button type="text"
                 @click="_toggleShowMore">{{ showMore ? $t('gamelist.retract') : $t('gamelist.more')}}</el-button> -->
    </div>
    <div class="wrapper-container">
      <!-- overflow: hidden：清除子元素相对父元素的超界溢出 -->
<!--      <div style="overflow: hidden"
           :style="{height : showMore ? 'auto': showHeight + 'px'}"> -->
		<div class="hotgamelist-box" style="overflow: hidden">
        <div class="hot-game-list">
          <div class="HotsGame"
               v-for="(item, ind) in content"
               :key="ind"
               @click="ToProduct(item.game_id)">
            <img :src='item.logo_url'>
            <p>{{item.game_name}}</p>
          </div>
        </div>
      </div>

      <!-- <div class="control"
           v-show="isLongContent"
           :class="{'show-more' : showMore}">
        <el-button type="text"
                   @click="_toggleShowMore">{{ showMore ? '收起' : '显示更多'}}</el-button>
      </div> -->
    </div>
    <!-- <el-scrollbar>
      <div class="HotsGameCont">
        <div class="HotsGame"
             v-for="(item, ind) in GameListArr"
             :key="ind"
             @click="ToProduct(item.id)">
          <img src="../assets/images/a.png"
               alt="">
          <p>{{item.gameName}}</p>
        </div>
      </div>
    </el-scrollbar> -->
  </div>

</template>

<script>
//import 'element-ui/lib/theme-chalk/display.css'
export default {
  props: {
    // showHeight: {
    //   type: Number,
    //   required: true,
    //   default: 200
    // },
    content: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      showMore: false,
      isLongContent: false
    }
  },
  watch: {
    // 每当内容变化时都重新计算一次高度
    content () {
      this._calculateHeight()
    }
  },
  methods: {
    toMore () {
      this.$router.push({
        path: `/allGames`
      })
    },
    ToProduct (id) { // 跳转游戏详情
      this.$router.push({
        path: `/product?id=${id}`
      })
    },
    refresh () {
      this._calculateHeight()
    },
    _calculateHeight () {
      // $nextTick()，等待内容获取完毕再计算高度，异步处理
      // this.$nextTick().then(() => {
      //   let contentHeight = this.$refs.content[0].clientHeight
      //   if (contentHeight > this.showHeight) {
      //     this.isLongContent = true
      //   } else {
      //     this.isLongContent = false
      //   }
      // })
    },
    _toggleShowMore () {
      this.showMore = !this.showMore
    }
  }
}
</script>

<style scoped>
.TitleFont {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 1.333rem;
  padding-left: 0.667rem;
  margin: 1.333rem 0 0 0;
  padding: 0;
  /* border-bottom: 1px solid #ddd; */
}
.TitleFont > p {
  color: #333;
  padding-left: 8px;
  border-left: 0.5rem solid #ff7473;
}

.hot-game-list {
  display: flex;
  flex-wrap: wrap;
}
.HotsGameCont {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-around; */
  max-height: 20.25rem;
  overflow: hidden;
}
.HotsGame {
  cursor: pointer;
  background: white;
  width: 8rem;
  margin: 6px 2px 6px 11px;
  border-radius: 2px;
  text-align: center;
  /* box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2); */
}
.HotsGame > img {
  width: 6rem;
  height: 6rem;
  border-radius: 1rem;
  margin-top: 1.2rem;
}
.HotsGame > p {
  overflow: hidden;
  max-height: 2.5rem;
  line-height: 2.5rem;
}

.wrapper-container {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  background: #fff;
  position: relative;
  border-radius: 3px;
  /* padding-bottom: 10px; */
}
.hotgamelist-box{
	height: 129px;
}
@media (max-width: 768px) {
	.hotgamelist-box{
		height: 270px;
	}
}
@media (max-width: 576px) {
	.hotgamelist-box{
		height: 270px;
	}
}
.wrapper-container .control {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-top: 40px;
  text-align: center;
  background-image: linear-gradient(
    -180deg,
    rgba(255, 255, 255, 0) 0%,
    #fff 70%
  );
}
.show-more {
  padding-top: 0;
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/module/gamelist.vue